<div class="info-area">
  <div class="info-title">Biz-Marcheプロジェクト進行中です！</div>
  <div class="info-main">（ここにアカウント未登録者を含む全員向けのメッセージ・コンテンツが入る）</div>
</div>
<div class="info-area">
  <div class="position-center">
    <div class="welecome-card">
      @for (item of icons; track $index) {
      <app-link-icon (clicked)="clickMenu($event)" [icon]="item"></app-link-icon>
      }
    </div>
  </div>
</div>
